export const PARALYMPIC_STORE_PATH = "/ipromiseafrica/the-able/equipment";
export const PARALYMPIC_STORE_ROUTE = "ParalympicStore";
export const PARALYMPIC_DETAIL_ROUTE = "ParalympicEquipmentDetail";

export const PARALYMPIC_API = {
  list: "/api/paralympic/equipment",
  detail: (slug) => `/api/paralympic/equipment/${encodeURIComponent(slug)}`,
};
